import { useEffect, useRef } from 'react';
import { bind as bindAuthKana } from '../../vendor/AutoKana';
/**
 * @deprecated TS化済: src/hooks/form/useAutoKana.ts
 */
export const useKanaEffect = (kanaRef, lastNameSelector = '', firstNameSelector = '') => {
    // ふりがな取得
    useEffect(() => {
        const lastKana = bindAuthKana(lastNameSelector || '#lastName', '');
        const firstKana = bindAuthKana(firstNameSelector || '#firstName', '');
        // eslint-disable-next-line no-param-reassign
        kanaRef.current.last = lastKana;
        // eslint-disable-next-line no-param-reassign
        kanaRef.current.first = firstKana;
        return () => {
            lastKana.removeEvents();
            firstKana.removeEvents();
        };
    }, [lastNameSelector, firstNameSelector, kanaRef]);
};
/**
 * kanaの取得
 * @returns {React.MutableRefObject<{last: null|AutoKana, first: null|AutoKana}>}
 */
export const useKanaRef = () => useRef({ first: null, last: null });
